import Link from "next/link";
import { Mail, MapPin, Phone, Clock } from "lucide-react";

import { NewsletterSignupForm } from "@/features/newsletter/components/NewsletterSignupForm";

export function PublicSiteFooter() {
  return (
    <footer className="border-t border-border bg-background text-foreground/80">
      <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
        <div className="grid gap-6 md:grid-cols-4">
          <div className="rounded-2xl border border-border bg-muted p-5">
            <div className="mb-3 text-2xl font-black tracking-tight text-emerald-600">
              Efasol
            </div>
            <p className="text-sm leading-6 text-muted-foreground">
              Fresh produce from local farm shops.
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-base font-semibold text-foreground">Quick Links</h3>
            <ul className="space-y-3 text-sm">
              <li><Link href="/" className="hover:text-emerald-600">About us</Link></li>
              <li><Link href="/shop" className="hover:text-emerald-600">Shop</Link></li>
              <li><Link href="/shop/store-list" className="hover:text-emerald-600">Local Stores</Link></li>
              <li><Link href="/login" className="hover:text-emerald-600">Contact us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-base font-semibold text-foreground">Categories</h3>
            <ul className="space-y-3 text-sm">
              <li><Link href="/shop?category=vegetables" className="hover:text-emerald-600">Vegetables</Link></li>
              <li><Link href="/shop?category=fruits" className="hover:text-emerald-600">Fruits</Link></li>
              <li><Link href="/shop?category=grains" className="hover:text-emerald-600">Grains</Link></li>
              <li><Link href="/shop?category=livestock" className="hover:text-emerald-600">Livestock</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-base font-semibold text-foreground">Newsletter</h3>
            <p className="mb-4 text-sm leading-6 text-muted-foreground">
              Get updates and offers.
            </p>
            <NewsletterSignupForm />
          </div>
        </div>

        <div className="mt-8 grid gap-4 border-t border-border pt-6 text-sm text-muted-foreground md:grid-cols-4">
          <div className="flex items-start gap-3">
            <MapPin className="mt-0.5 h-4 w-4 text-emerald-600" />
            <span>Serving the whole region.</span>
          </div>
          <div className="flex items-start gap-3">
            <Phone className="mt-0.5 h-4 w-4 text-emerald-600" />
            <span>+254 700 000 000</span>
          </div>
          <div className="flex items-start gap-3">
            <Clock className="mt-0.5 h-4 w-4 text-emerald-600" />
            <span>Monday - Friday: 9AM - 6PM</span>
          </div>
          <div className="flex items-start gap-3">
            <Mail className="mt-0.5 h-4 w-4 text-emerald-600" />
            <span>support@efasolsolutions.com</span>
          </div>
        </div>

        <div className="mt-8 border-t border-border pt-5 text-center text-xs text-muted-foreground">
          © 2026 Efasol. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
